import { render, staticRenderFns } from "./returned-unit-table.vue?vue&type=template&id=af42d92c&"
import script from "./returned-unit-table.vue?vue&type=script&lang=js&"
export * from "./returned-unit-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports